const React = require('react');
const {LINK_DEVELOPER_OPTIONS, LINK_CREATE_CRYPTO_WALLET, LINK_WITHDRAW} = require("../../../../../constants/links");
const Tooltip = require("../../../../dumb/Tooltip/A");
const onAppChange = require('./onAppChange');

module.exports = ({assetCode, appsList, formCtx}) => {
  const propValue = 'id';

  const {data, errors, click} = formCtx.state;

  const appBalance = data['appBalance'] || [];

  const appSelectId = 'app_id';
  const selectedApp = data[appSelectId];
  const selectedError = errors[appSelectId];

  const walletsList = data['walletsList'] || [];

  const walletSelectId = 'crypto_wallet_id';
  const walletCreationLink = selectedApp
    && `${LINK_DEVELOPER_OPTIONS}/${selectedApp}${LINK_CREATE_CRYPTO_WALLET}?backPath=withdraw&asset=${assetCode}`;
  const walletSelectLabel = `Select ${assetCode} wallet (${
    selectedApp ? `available: ${walletsList.length}` : 'select app first'
  })`;

  const appSelectProps = {
    name: appSelectId,
    label: 'Select application',
    propValue,
    propName: ({name, hasBalance}) => hasBalance
      ? name
      : (
        <div className="w layoutRow jcSB aiC">
          <div>{name}</div>
          <div className={`ml10 f10 fw3 tr cFF481F`}>
            Empty balance
          </div>
        </div>
      ),
    items: appsList,
    value: selectedApp,
    error: selectedError,
    showError: click && selectedError,
    onChange: onAppChange({
      assetCode,
      walletSelectId,
      formCtx
    })
  };

  const walletSelectProps = {
    name: walletSelectId,
    label: walletSelectLabel,
    propValue,
    propName: (el) => {
      const address = el.address;

      const LABEL_LENGTH = 8;

      const ellipsisMiddle = (text, length) => text.length > length
        ? `${text.slice(0, length)}...${text.slice(text.length - length, text.length)}`
        : text;

      return (
        <div className="w layoutRow jcSB aiC">
          {address.length > LABEL_LENGTH
            ? (
              <Tooltip
                title={address}
                disabledCopy
              >
                {ellipsisMiddle(address, LABEL_LENGTH)}
              </Tooltip>
            ) : (
              <span>{ellipsisMiddle(address, LABEL_LENGTH)}</span>
            )
          }
          <div className={`fw3 tr c2CE889 cFFBF43.disabled ` + (el.disabled ? ' disabled' : '')}>
            {el.disabled ? 'Disabled' : 'Enabled'}
          </div>
        </div>
      )
    },
    items: walletsList,
    disabled: !selectedApp || walletsList.length < 2,
    formCtx
  };

  return {appBalance, appSelectProps, walletSelectProps, walletCreationLink};
}
